import { useWorkspaceSettings } from "@/hooks/use-workspace-settings";
import { Loader2 } from "lucide-react";
import WorkflowSettingsOriginal from "@/components/workspace-settings/workflow";
import { DiligenceDepthSettings } from "./diligence-depth-settings";

export default function WorkflowSettings() {
  const { workspace, isLoading } = useWorkspaceSettings();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
      </div>
    );
  }

  if (!workspace) {
    return (
      <div className="flex items-center justify-center h-64 text-muted-foreground">
        No workspace found
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-2xl px-6 py-8">
      <h1 className="text-lg font-semibold text-foreground">Workflow</h1>
      <p className="mt-0.5 text-sm text-muted-foreground">
        How deals are analysed when they arrive, and the statuses they move
        through.
      </p>
      <div className="mt-8">
        <DiligenceDepthSettings />
      </div>
      <div className="mt-8">
        <WorkflowSettingsOriginal workspace={workspace} />
      </div>
    </div>
  );
}
